import styled from 'styled-components';

export const StyledFileUploadWrapper = styled.div`
  display: flex;
  justify-content: ${(props) => (props.asButton ? 'center' : 'flex-start')};
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${(props) => (props.asButton ? '4px' : props.borderRadius || '8px')};
    font-size: ${(props) => (props.asLabel ? '15px' : props.fontSize || '14px')};
    padding: ${(props) =>
      props.asLabel ? '0px' : props.asButton ? '5px 10px' : props.padding || '7px 20px'};
    border: ${(props) => (props.asLabel ? 'none' : props.border ||'1px solid #a0a0a0')};
    background-color: ${(props) => (props.asLabel ? '#e4e4e5' : props.asMioEditorButton ? '#6351ed' : props.background || '#eeeeee')};
    font-weight: ${(props) => (props.asLabel ? '600' : '400')};
    margin: ${(props) =>
      props.fromInviteClients ? '0 17px 0 0' : props.margin ? props.margin : props.asLabel ? '10px 0px 0px' : props.asButton ? '10px 0 0 0' : '0px'};
    float: ${(props) => (props.asLabel ? 'left' : 'none')};
    width: ${(props) => (props.asButton ? '130px' : props.width || 'auto')};
    font-family: 'Poppins';
    color: ${(props) => (props.asMioEditorButton ? '#eeeeee' : props.color ||'#6351ed')};
    cursor: pointer;
    height: ${({ height }) => height || ''};
    &:hover {
      background-color: ${(props) => (props.asLabel ? 'transparent' : '#eee')};
      color: ${(props) =>
        props.asLabel ? '#6351ed' : props.asButton ? '#6351ed' : 'initial'};
    }
    &:before {
      padding-right: 4px;
      font-size: 18px;
    }
  }
`;
